import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export type VanityLinkErrorCode =
	| 'INVALID_LENGTH'
	| 'INVALID_URL'
	| 'GENERIC_ERROR'
	| 'UNAUTHENTICATED'
	| 'ALREADY_EXISTS'
	| 'BANNED_WORD';

type VanityLinkErrorType = {
	code: VanityLinkErrorCode;
	message: TranslationKey;
};

export const VANITY_ERROR_MAP: Record<VanityLinkErrorCode, VanityLinkErrorType> = {
	INVALID_LENGTH: {
		code: 'INVALID_LENGTH',
		message: translationKey('corgi.petition.starter_dashboard.grow_petition.copy_link.invalid_length_error'),
	},
	INVALID_URL: {
		code: 'INVALID_URL',
		message: translationKey('corgi.petition.starter_dashboard.grow_petition.copy_link.invalid_format_error'),
	},
	GENERIC_ERROR: {
		code: 'GENERIC_ERROR',
		message: translationKey('corgi.petition.starter_dashboard.grow_petition.copy_link.generic_error'),
	},
	UNAUTHENTICATED: {
		code: 'UNAUTHENTICATED',
		message: translationKey('corgi.petition.starter_dashboard.grow_petition.copy_link.authenticated_error'),
	},
	BANNED_WORD: {
		code: 'BANNED_WORD',
		message: translationKey('corgi.petition.starter_dashboard.grow_petition.copy_link.banned_word_error'),
	},
	ALREADY_EXISTS: {
		code: 'ALREADY_EXISTS',
		message: translationKey('corgi.petition.starter_dashboard.grow_petition.copy_link.vanity_link_error'),
	},
};

// oxlint-disable-next-line typescript-eslint/consistent-type-assertions
export const vanityLinkErrorCodes = Object.keys(VANITY_ERROR_MAP) as ReadonlyArray<keyof typeof VANITY_ERROR_MAP>;
